import React from 'react';

/**
 * Standard button. Variants map to the brand token classes in index.css
 * (@layer components) so the indigo brand color lives in one place.
 *
 * Props:
 *   variant — 'primary' (default) | 'secondary' | 'gradient' | 'danger'
 *   size    — 'md' (default) | 'sm' | 'lg'
 *   className, ...props (onClick, disabled, type, etc.)
 */
const VARIANTS = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  gradient: 'btn-gradient',
  danger: 'btn-danger',
};

const SIZES = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-4 py-2 text-sm',
  lg: 'px-6 py-3 text-sm',
};

const Button = ({ variant = 'primary', size = 'md', className = '', children, ...props }) => (
  <button
    type="button"
    className={`inline-flex items-center justify-center font-medium disabled:opacity-50 disabled:cursor-not-allowed transition-colors ${SIZES[size] || SIZES.md} ${VARIANTS[variant] || VARIANTS.primary} ${className}`}
    {...props}
  >
    {children}
  </button>
);

export default Button;
